var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-popover',{staticClass:"wrapper",attrs:{"trigger":"hover"}},[_c('i',{staticClass:"icon material-icons"},[_vm._v("\n    info\n  ")]),_c('template',{slot:"popover"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }